<template>
	<div class="login recover-password">
		<fyi-logo></fyi-logo>
		<div :class="['form-container', {'no-info': email == ''},  {'revoke': revoke == 'true'}, {'otp-screen': showOTP}]">
			<div v-if="revoke" class="pre-change">
				<div class="animation"></div>
				<label class="title">Nova password anulada</label>
				<label class="description">Por razões de segurança, sugerimos que altere a sua palavra passe atual.</label>
				<fyi-button
					:label="'Alterar palavra-passe'"
					:className="'default'"
					:onclick="() => {revoke=false}"
				>
				</fyi-button>
				<fyi-button
					:label="'Login'"
					:className="'default'"
					:onclick="() => {$router.push({ name: 'login' })}"
				>
				</fyi-button>				
			</div>
			<div v-if="!showOTP && !revoke" class="step-1">
				<fyi-logo></fyi-logo>
				<fyi-email
					v-bind:value="email"
					@input-email="email = $event"
					@email-valid="email_valid = $event"
					:alias="'email'"
					:label="'E-mail'"
					:placeholder="'Insira o e-mail registado'"
					:disabled="true"
					:required="true"
					:inputError="false"
				/>
				<fyi-password
					v-bind:value="new_password"
					v-on:input-password="new_password = $event"
					:alias="'password'"
					:label="'Nova palavra-passe'"
					:show="true"
					:placeholder="'● ● ● ● ● ●'"
					:errorType="input_1_error_type"
					:disabled="submitStatus == 'TOKEN_NOT_FOUND'"      
					:required="true"
					@submit="handleSubmit()"
				/>
				<fyi-password
					v-bind:value="repeat_password"
					v-on:input-password="repeat_password = $event"
					:alias="'password'"
					:label="'Repetir palavra-passe'"
					:show="true"
					:placeholder="'● ● ● ● ● ●'"
					:errorMessage="input_2_error_message"
					:errorType="input_2_error_type"
					:disabled="submitStatus == 'TOKEN_NOT_FOUND'"      
					:required="true"
					@submit="handleSubmit()"
				/>
				<fyi-checkbox alias="remember-user" label="Recordar acessos de entrada"    
					:value="remember_user"  
					:checked="remember_user"                
					:disabled="submitStatus == 'TOKEN_NOT_FOUND'"      
					v-on:input="rememberUser($event.checked)"
					type="all"/>
				<fyi-button
					:label="'Vamos lá!'"
					:className="'default'"
					:loading="submitStatus=='PENDING'"
					:disabled="input_1_error_type != 'valid' || input_2_error_type!='valid' || submitStatus == 'TOKEN_NOT_FOUND'"
					:onclick="() => {handleSubmit()}"
				>
				</fyi-button>
			</div>
			<otp v-if="showOTP && submitStatus != 'SUCCESS'" :className="'step-2'"
			ref='otp'
			@resend-otp="handleSubmit(true)"
			@submit-otp="handleSubmitOtp($event)"
			@go-back="goBack()"
			>
			</otp>
			<div v-if="submitStatus == 'SUCCESS'" class="step-success">
				<div class="animation"></div>
				<label v-if="$route.path.includes('recover-password')">Palavra-passe alterada com sucesso</label>
				<label v-else>Bem vindo!</label>
			</div>
			<label v-if="errorMessage != ''" class="error-label">
				{{errorMessage}}
			</label>
		</div>
		<div class="footer">
			© {{new Date().getFullYear()}} . All Rights Reserved. Konstruck by <img src="../../assets/images/fyi.svg">
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
export default {
	name: "RecoverPassword",
	data: function() {
		return {
			revoke: this.$route.query.revoke,
			user_id: '',
			email: '',
			errorMessage: '',
			submitStatus: "READY",
			submitStatusResendOTP: "READY",
			new_password: "",
			repeat_password: "",
			input_1_error_type: "",
			input_2_error_type: "",
			input_2_error_message: "As passwords não coincidem",
			invalid: false,
			remember_user: false,
			showOTP: false,
		};
	},	
	watch: {
		repeat_password(_new, _old){
			if(_new == this.new_password){
				this.input_2_error_type = 'valid'
				this.input_2_error_message = this.$t('error_4')
			}else{
				this.input_2_error_type = 'warning'
				this.input_2_error_message = this.$t('error_5')
			}
		},
		new_password(_new, _old){
			let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[\\\-_!@#\$%\^&\*\?\.])(?=.{8,})"); //add (?=.*[0-9]) if numeric char required
			if(strongRegex.test(_new)){
				this.input_1_error_type = 'valid'
			}else{
				this.input_1_error_type = 'warning'
			}

			if(_new == this.repeat_password){
				this.input_2_error_type = 'valid'
				this.input_2_error_message = this.$t('error_4')
			}else{
				this.input_2_error_type = 'warning'
				this.input_2_error_message = this.$t('error_5')
			}
		},
		submitStatus(_new, _old){
			if(_new == "ERROR"){
				this.errorMessage = this.$t('error_6')
			}else if(_new == "OTP_ERROR"){
				this.errorMessage = this.$t('error_7')
			}else if(_new == "TOKEN_NOT_FOUND"){
				this.errorMessage = this.$t('error_8')
			}else if(_new == "PASSWORD_USED"){
				this.errorMessage = this.$t('error_9')
			}else{
				this.errorMessage = "";
			}
		}
	},
	computed: {
		otp(){
			if(this.otp_1 !== '' && this.otp_2 !== '' && this.otp_3 !== '' && this.otp_4 !== '')
				return this.otp_1 + this.otp_2 + this.otp_3 + this.otp_4;

			return ''
		}
	},
	async beforeMount(){
		try{
			let token = this.$route.query.token || this.$route.params.token;
			if(this.$route.query.revoke)
				this.email = ' '

			let func = "getUserByToken"
			if(this.$route.path.includes("recover-password")){
				func = "getUserByResetToken"
			}

			let user = await this[func]({token: token})
			this.email = user.email
			this.user_id = user.id
			if(this.$route.query.revoke || this.$route.query.revoke == 'true')
				await this.revokePasswordChange({user_id:this.user_id});

		}catch(err){
			console.log(err);
			this.email = ' '
			this.submitStatus = "TOKEN_NOT_FOUND";
		}

	},
	beforeUnmount(){
		this.showOTP = false;
		this.new_password = ''
		this.repeat_password = ''
	},
	methods: {
		...mapActions(["reset", "getUserByResetToken", "getUserByToken", "validateOtp", "sendOtp", "updatePassword", "revokePasswordChange", "validatePassword"]),
		rememberUser(flag){
			if(flag){
				window.localStorage.setItem('email_remember', this.email)
			}else{
				window.localStorage.removeItem('email_remember')
			}
		},
		goBack(){
			this.new_password = ''
			this.repeat_password = ''
			this.showOTP = false;
		},
		handleSubmit( flag = false) {
			const { user_id, input_1_error_type, input_2_error_type} = this;

			if(input_1_error_type != 'valid' || input_2_error_type != 'valid')
				return;

			if(!flag)
				this.submitStatus = "PENDING";
			else
				this.submitStatusResendOTP = "PENDING"

			if(!flag){
				this.validatePassword({ user_id: user_id, password: this.new_password }).then( response => {
					if(response == true)
						this.otpSend(flag);
					else
						this.submitStatus = "PASSWORD_USED";
				}).catch( (error) => {
					this.submitStatus = "PASSWORD_USED";
				});
			}else{
				this.otpSend(flag);
			}
		},
		otpSend(flag){
			const { user_id} = this;
			this.sendOtp({ id: user_id })
				.then(() => {
					if(flag)
						this.$refs.otp.handleTimer();

					this.submitStatus = "READY";
					this.submitStatusResendOTP = "READY"
					this.showOTP = true;
				})
				.catch(err => {
					console.log(err);
					this.submitStatus = "ERROR";
					this.errorMessage = err.message;
				});
		},
		handleSubmitOtp(data){
			const _this = this;
			const { new_password, user_id } = this;
			const { otp } = data;
			this.submitStatus = "PENDING";
			let token = this.$route.query.token || this.$route.params.token;
			this.validateOtp({id: user_id, otp: otp}).then(() => {
				let func = "updatePassword"
				if(this.$route.path.includes("recover-password")){
					func = "reset"
				}
				this[func]({ password: new_password, token })
				.then(() => {
					this.submitStatus = "SUCCESS";
					setTimeout(function(){
						bodymovin.loadAnimation({
							container: document.querySelector('.step-success .animation'),
							animationData: {"v":"5.6.1","fr":60,"ip":0,"op":93,"w":90,"h":90,"nm":"Cashback Activation Animation","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"check","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[46,46,0],"ix":2},"a":{"a":0,"k":[-64.139,-543.26,0],"ix":1},"s":{"a":0,"k":[39.706,39.706,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.841,0.133],[-0.919,-0.115]],"o":[[0,0],[0.059,0.133],[-1.115,-0.102]],"v":[[-24.839,-568.19],[-76.231,-518.331],[-103.417,-545.583]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":62,"s":[0],"e":[100]},{"t":63}],"ix":4},"w":{"a":0,"k":18,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.673],"y":[1]},"o":{"x":[0.34],"y":[0]},"t":62,"s":[0],"e":[100]},{"i":{"x":[0.477],"y":[0.892]},"o":{"x":[0.061],"y":[0]},"t":63,"s":[100],"e":[0]},{"t":88}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"gr","it":[{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":13,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":1,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":935,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"bg","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[45,45,0],"ix":2},"a":{"a":0,"k":[16.233,24.733,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.385,0.385,0.663],"y":[0.996,0.996,-36.691]},"o":{"x":[0.369,0.369,0.296],"y":[0,0,0]},"t":47,"s":[0,0,100],"e":[156.367,156.367,100]},{"i":{"x":[0.558,0.558,0.812],"y":[1.011,1.011,1]},"o":{"x":[0.239,0.239,0.427],"y":[-0.017,-0.017,33.575]},"t":74,"s":[156.367,156.367,100],"e":[128.636,128.636,100]},{"t":93}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[15.317,0],[0,-15.317],[-15.317,0],[0,15.317]],"o":[[-15.317,0],[0,15.317],[15.317,0],[0,-15.317]],"v":[[0,-27.733],[-27.733,0],[0,27.733],[27.733,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[16.233,24.733],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":2400,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"progress","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[45,45,0],"ix":2},"a":{"a":0,"k":[111.5,111.5,0],"ix":1},"s":{"a":0,"k":[47,47,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-46.392,0],[0,46.392],[46.392,0],[0,-46.392]],"o":[[46.392,0],[0,-46.392],[-46.392,0],[0,46.392]],"v":[[0,84],[84,0],[0,-84],[-84,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":17,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[111.5,111.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.783],"y":[0]},"t":0,"s":[100],"e":[0]},{"t":53}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-34,"op":967,"st":180,"bm":0}],"markers":[]},
							renderer: 'svg',
							loop: false,
							autoplay: true
						});
						setTimeout(function(){
							_this.$router.push({ name: "login" });
						}, 2000)
					}, 100)
				})
				.catch(err => {
					console.log(err);
					this.submitStatus = "ERROR";
					this.errorMessage = err.message;
				});
			}).catch((err) => {
				console.log(err);
				this.submitStatus = "OTP_ERROR";
			})

		},
		redirectLogin() {
			this.$router.push({ name: "login" });
		}
	},
	mounted(){
		if(this.revoke){
			setTimeout(function(){
				bodymovin.loadAnimation({
					container: document.querySelector('.pre-change .animation'),
					animationData: {"v":"5.6.1","fr":60,"ip":0,"op":93,"w":90,"h":90,"nm":"Cashback Activation Animation","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"check","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[46,46,0],"ix":2},"a":{"a":0,"k":[-64.139,-543.26,0],"ix":1},"s":{"a":0,"k":[39.706,39.706,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.841,0.133],[-0.919,-0.115]],"o":[[0,0],[0.059,0.133],[-1.115,-0.102]],"v":[[-24.839,-568.19],[-76.231,-518.331],[-103.417,-545.583]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":62,"s":[0],"e":[100]},{"t":63}],"ix":4},"w":{"a":0,"k":18,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.673],"y":[1]},"o":{"x":[0.34],"y":[0]},"t":62,"s":[0],"e":[100]},{"i":{"x":[0.477],"y":[0.892]},"o":{"x":[0.061],"y":[0]},"t":63,"s":[100],"e":[0]},{"t":88}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"gr","it":[{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":13,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":1,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":935,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"bg","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[45,45,0],"ix":2},"a":{"a":0,"k":[16.233,24.733,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.385,0.385,0.663],"y":[0.996,0.996,-36.691]},"o":{"x":[0.369,0.369,0.296],"y":[0,0,0]},"t":47,"s":[0,0,100],"e":[156.367,156.367,100]},{"i":{"x":[0.558,0.558,0.812],"y":[1.011,1.011,1]},"o":{"x":[0.239,0.239,0.427],"y":[-0.017,-0.017,33.575]},"t":74,"s":[156.367,156.367,100],"e":[128.636,128.636,100]},{"t":93}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[15.317,0],[0,-15.317],[-15.317,0],[0,15.317]],"o":[[-15.317,0],[0,15.317],[15.317,0],[0,-15.317]],"v":[[0,-27.733],[-27.733,0],[0,27.733],[27.733,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[16.233,24.733],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":2400,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"progress","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[45,45,0],"ix":2},"a":{"a":0,"k":[111.5,111.5,0],"ix":1},"s":{"a":0,"k":[47,47,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-46.392,0],[0,46.392],[46.392,0],[0,-46.392]],"o":[[46.392,0],[0,-46.392],[-46.392,0],[0,46.392]],"v":[[0,84],[84,0],[0,-84],[-84,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":17,"ix":5},"lc":2,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[111.5,111.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.783],"y":[0]},"t":0,"s":[100],"e":[0]},{"t":53}],"ix":1},"e":{"a":0,"k":100,"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-34,"op":967,"st":180,"bm":0}],"markers":[]},
					renderer: 'svg',
					loop: false,
					autoplay: true
				});
			}, 100)
		}

	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.submit-ok {
	width: 100%;
	text-align: center;
	padding: 20px;
	font-weight: bold;
	color: green;
	> i {
		vertical-align: middle;
		margin-left: 10px;
		font-size: 24px;
		color: green;
	}
}

.form-redirect {
	// margin-top: 2rem;
}
</style>
